import React from "react";
import RoomCard from "./RoomCard";
import { useNavigate } from "react-router-dom";
import { calculatePriceWithMarkup, getMarkupFromURL } from "../../utils/markupCalculation";

const ExploreRooms = ({
    data,
    ...props
}) => {
    const navigate = useNavigate();
    const markupValue = getMarkupFromURL();

    const handleExploreRoom = (room) => {
        navigate(`/property-landing-page/room/${room.name?.replace(/ /g, "-")}`, { 
            state: { 
                room, 
                markup: markupValue,
                ...props 
            } 
        });
    }

    return (
        <div className="bg-gray-100 py-16 md:px-6">
            {/* Title */}
            <h2 className="text-center text-2xl mb-10">
                Explore our designed rooms
            </h2>

            {/* Room Cards */}
            <div className="grid grid-cols-1 gap-6 max-w-5xl mx-auto">
                {
                    data?.rooms?.
                        map((room, index) => (
                            <RoomCard
                                key={index}
                                imageSrc={room?.images && room?.images[0]?.src || ""}
                                roomName={room?.name}
                                price={calculatePriceWithMarkup(room?.cost, markupValue)}
                                handleExplore={() => handleExploreRoom(room)}
                            />
                        ))
                }
            </div>
        </div>
    );
};

export default ExploreRooms;
